// Centralized station model identifiers to avoid duplicated string literals
export const STATION_MODEL_ID = {
  MIX_OBS: "mix-obs",
  MM_MOS: "mm-mos",

  AARGAU: "aargau-road-stations",
  NATIONALSTRASSEN: "nationalstrassen-road-stations",
  ZENTRAS: "zentras-road-stations",

  GOTTHARD: "gotthard-road-stations",
  NSNW: "nsnw-road-stations",
} as const;

export type StationModelId = (typeof STATION_MODEL_ID)[keyof typeof STATION_MODEL_ID];

export const STATION_MODEL_LABEL = {
  AARGAU: "Aargau Road Stations",
  NATIONALSTRASSEN: "ASTRA Road Stations",
  ZENTRAS: "Zentras Road Stations",
  GOTTHARD: "Gotthard Road Stations",
  NSNW: "NSNW Road Stations",
} as const;

export type StationModelLabel = (typeof STATION_MODEL_LABEL)[keyof typeof STATION_MODEL_LABEL];
